import script from "./UserSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSection.vue?vue&type=script&setup=true&lang=ts"

import "./UserSection.vue?vue&type=style&index=0&id=12cd837a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12cd837a"]])

export default __exports__